module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "forums"
    }
  }, [(_vm.board !== undefined) ? [(!_vm.isCategorySet) ? _c('category-list', {
    attrs: {
      "board-id": _vm.boardId,
      "board": _vm.board,
      "root": "Forums",
      "is-moderator": _vm.isModerator,
      "can-post": _vm.canPost
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && !_vm.isForumSet) ? _c('forum-list', {
    attrs: {
      "board-id": _vm.boardId,
      "board": _vm.board,
      "root": "Forums",
      "is-moderator": _vm.isModerator,
      "can-post": _vm.canPost
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && _vm.isForumSet && !_vm.isThreadSet) ? _c('thread-list', {
    attrs: {
      "board-id": _vm.boardId,
      "board": _vm.board,
      "root": "Forums",
      "is-moderator": _vm.isModerator,
      "can-post": _vm.canPost
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && _vm.isForumSet && _vm.isThreadSet) ? _c('post-list', {
    attrs: {
      "board-id": _vm.boardId,
      "board": _vm.board,
      "root": "Forums",
      "is-moderator": _vm.isModerator,
      "can-post": _vm.canPost
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61c078fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Forums/ForumsPage.vue
// module id = 877
// module chunks = 2